import * as Automerge from '@automerge/automerge';
import { WEBSOCKET_ACTIONS } from './websocket';
const MINIMUM_GAP_BETWEEN_UPDATES_MS = 30;
export class SyncDocClient extends EventTarget {
    _socket;
    static create(socket) {
        return new SyncDocClient(socket);
    }
    _syncState = Automerge.initSyncState();
    _doc = Automerge.init();
    _hasDoc;
    _hasDocResolve;
    _pendingIncomingMessages = [];
    _updateTimeout;
    _lastTimeoutTime = 0;
    constructor(_socket) {
        super();
        this._socket = _socket;
        this._socket.addMessageListener(WEBSOCKET_ACTIONS.AutomergeInit, this._onDocInit.bind(this));
        this._socket.addMessageListener(WEBSOCKET_ACTIONS.AutomergeSync, this._onUpdateFromServer.bind(this));
        this._socket.addEventListener('close', this.disconnect.bind(this));
        this._socket.addEventListener('error', this.disconnect.bind(this));
        this._hasDoc = new Promise(resolve => {
            this._hasDocResolve = resolve;
        });
    }
    waitForDoc() {
        return this._hasDoc;
    }
    disconnect() {
        this._socket.removeMessageListenersForAction(WEBSOCKET_ACTIONS.AutomergeInit);
        this._socket.removeMessageListenersForAction(WEBSOCKET_ACTIONS.AutomergeSync);
    }
    _onDocInit(_docStr) {
        const [newSyncState, message] = Automerge.generateSyncMessage(this._doc, this._syncState);
        this._socket.send(WEBSOCKET_ACTIONS.AutomergeSync, message);
        this._syncState = newSyncState;
    }
    _onUpdateFromServer(msgArray) {
        const msg = Uint8Array.from(msgArray);
        if (typeof this._updateTimeout === 'undefined') {
            this._receiveMessage(msg);
        }
        else {
            this._pendingIncomingMessages.push(msg);
        }
        this.dispatchEvent(new Event('sync'));
    }
    _receiveMessage(msg) {
        const [newDoc, newSyncState] = Automerge.receiveSyncMessage(this._doc, this._syncState, msg);
        this._doc = newDoc;
        this._syncState = newSyncState;
        if (this._hasDocResolve) {
            this._hasDocResolve();
            this._hasDocResolve = undefined;
        }
    }
    _processPendingComms() {
        const msgs = this._pendingIncomingMessages;
        this._pendingIncomingMessages = [];
        for (const msg of msgs) {
            this._receiveMessage(msg);
        }
        const [newSyncState, message] = Automerge.generateSyncMessage(this._doc, this._syncState);
        this._socket.send(WEBSOCKET_ACTIONS.AutomergeSync, message);
        this._syncState = newSyncState;
        this.dispatchEvent(new Event('sync'));
    }
    getDoc() {
        if (typeof this._doc === 'undefined')
            throw (`Undefined Automerge doc`);
        return this._doc;
    }
    change(callback) {
        this._doc = Automerge.change(this._doc, callback);
        this._postUpdate();
        if (typeof this._doc === 'undefined')
            throw (`Undefined Automerge doc`);
        return this._doc;
    }
    _postUpdate() {
        if (typeof this._updateTimeout === 'number')
            return;
        const currentTime = Date.now();
        const timeout = Math.max(MINIMUM_GAP_BETWEEN_UPDATES_MS - (currentTime - this._lastTimeoutTime), 1);
        this._updateTimeout = window.setTimeout(() => {
            if (typeof this._doc === 'undefined')
                throw (`Undefined Automerge doc`);
            this._lastTimeoutTime = Date.now();
            this._updateTimeout = undefined;
            this._processPendingComms();
        }, timeout);
    }
}
